import { Trans } from '@ui/i18n/trans';
import { useSettings } from '@ui/settings/use-settings';
import { IconButton } from 'rsuite';
import { CloseIcon } from '@ui/icons/material/Close';
import { EntryActionList } from './drive/entry-actions/entry-action-list';
import { DashboardNavbar } from '@common/ui/dashboard-layout/dashboard-navbar';
import { CreateNewButton } from './drive/layout/create-new-button';
import { SearchIcon } from '@ui/icons/material/Search';
import { useActiveWorkspaceId } from '@common/workspace/active-workspace-id-context';
import React, { Fragment, useContext, useEffect, useMemo, useState } from 'react'
import { Link, Navigate, NavLink, useLocation, useParams } from 'react-router-dom';
import { driveState, useDriveStore } from './drive/drive-store';
import { useLogout } from '@common/auth/requests/logout';
import { DRIVE_PAGES, makePartialFolderPage, SearchPage } from './drive/drive-page/drive-page';
import { StaticPageTitle } from '@common/seo/static-page-title';
import { FileUploadProvider } from '@common/uploads/uploader/file-upload-provider';
import { FileEntryUrlsContext } from '@common/uploads/file-entry-urls';
import ChatIcon from './drive/layout/icons/ChatIcon';
import PricePlansIcon from './drive/layout/icons/PricePlansIcon';
import GearIcon from './drive/layout/icons/GearIcon';
import SignoutIcon from './drive/layout/icons/SignoutIcon';
import { DashboardLayout } from '@common/ui/dashboard-layout/dashboard-layout';
// import { Navbar } from '@common/ui/navigation/navbar/navbar';
import { DashboardSidenav } from '@common/ui/dashboard-layout/dashboard-sidenav';
import { Sidebar } from './drive/layout/sidebar/sidebar';
import { DashboardContent } from '@common/ui/dashboard-layout/dashboard-content';
import { UploadQueue } from './drive/uploading/upload-queue';
import { EntryDragPreview } from './drive/file-view/entry-drag-preview';
import { FileUploadStoreOptions } from '@common/uploads/uploader/file-upload-store';
import { getActiveWorkspaceId } from '@common/workspace/active-workspace-id';
import { DashboardLayoutContext } from '@common/ui/dashboard-layout/dashboard-layout-context';
import { NavbarSearch } from './drive/search/navbar-search';
import { useAuth } from '@common/auth/use-auth';
import ThemeSwitch from './drive/layout/ThemeSwitch';
import { useThemeSelector } from '@ui/themes/theme-selector-context';
import axios from 'axios';
import { TextField } from '@ui/forms/input-field/text-field/text-field';
import { DialogTrigger } from '@ui/overlays/dialog/dialog-trigger';
import { DataTableAddItemButton } from '@common/datatable/data-table-add-item-button';
import { CreateUserDialog } from '@common/admin/users/create-user-dialog';
import CompanyTable from './company/CompanyTable';
import { AddMemberDialog } from './company/AddMemberDialog';
import { FormFileSizeField } from '@common/uploads/components/file-size-field';
import { Select } from '@nextui-org/react';
import { useQuery } from '@tanstack/react-query';
import { getcompanyMembersApi } from './company/api';
import { message } from '@ui/i18n/message';
import { useTrans } from '@ui/i18n/use-trans';

const uploadStoreOptions: FileUploadStoreOptions = {
  modifyUploadedFile: uploadedFile => {
    const workspaceId = getActiveWorkspaceId();
    uploadedFile.fingerprint = `${uploadedFile.fingerprint}-w-${workspaceId}`;
    return uploadedFile;
  },
};

export default function CompanyUsers() {
  const { pathname } = useLocation();
  const { hash } = useParams();
  const { workspaceId } = useActiveWorkspaceId();
  const activePage = useDriveStore(s => s.activePage);
  const { mutate: logout } = useLogout();
  let auth = useAuth();
  const plan = auth.getPlan();

  if (!plan?.company)
    return <Navigate to={'/'}></Navigate>

  // axios.get('/api/v1/company/1').then((data)=>{console.log(data);
  // }).catch((data)=>{console.log(data);})

  const { selectedTheme, selectTheme } = useThemeSelector();
  const { themes } = useSettings();

  function handleTheme() {
    if (themes?.user_change && !selectedTheme.is_dark) {
      selectTheme('dark');
    }
    else if (themes?.user_change && selectedTheme.is_dark) {
      selectTheme('light');
    }
  }

  useEffect(() => {
    driveState().setActivePage(
      DRIVE_PAGES.find(p => p.path === pathname) ||
      makePartialFolderPage(hash!),
    );
  }, [pathname, hash]);

  const urlsContextValue = useMemo(() => {
    return { workspaceId };
  }, [workspaceId]);

  useEffect(() => {
    return () => {
      driveState().reset();
    };
  }, []);

  return (

    <Fragment>
      {activePage?.label && (
        <StaticPageTitle>
          <Trans
            message={
              typeof activePage.label === 'string'
                ? activePage.label
                : activePage.label.message
            }
          />
        </StaticPageTitle>
      )}
      <FileUploadProvider options={uploadStoreOptions}>
        <FileEntryUrlsContext.Provider value={urlsContextValue}>
          <div className='flex w-full bg-main'>
            <div className='h-[100vh] min-w-[90px] py-20 hidden lg:flex flex-col justify-between items-center'>
              <div className="flex flex-col items-center justify-center gap-20">
                {auth.hasRole(1) ? <></> : <NavLink to={'/admin'} className={'side-tabs-icon'}>
                  <i className="fa-solid fa-user-tie "></i>
                </NavLink>}
                <NavLink to={'/drive'} className={'side-tabs-icon'}>
                  <i className="fa-regular fa-folder-open "></i>
                </NavLink>
                <NavLink to={'/chat'} className={'side-tabs-icon'}>
                  <ChatIcon></ChatIcon>
                </NavLink>
                <NavLink to={'/pricing'} className={'side-tabs-icon'}>
                  <PricePlansIcon></PricePlansIcon>
                </NavLink>
                <NavLink to={'/account-settings'} className={'side-tabs-icon'}>
                  <GearIcon></GearIcon>
                </NavLink>
                <NavLink to={'/company-users'} className={'side-tabs-icon'}>
                  <i className='fa-solid fa-user-group text-lg px-2'></i>
                </NavLink>

              </div>
              <div className='flex flex-col items-center gap-20'>
                <ThemeSwitch onChange={handleTheme} isSelected={selectedTheme.is_dark}></ThemeSwitch>
                <button className='cursor-pointer' onClick={() => logout()}>
                  <SignoutIcon></SignoutIcon>
                </button>
              </div>
            </div>
            <div className='flex-grow ms-auto lg:rounded-tl-[100px] lg:rounded-bl-[100px] overflow-x-hidden bg-alt'>
              <DashboardLayout
                name="drive"
                onDragOver={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  e.dataTransfer.dropEffect = 'none';
                }}
                onDrop={e => {
                  // prevent files from desktop from blowing away the document
                  e.preventDefault();
                }}
              >
                {/* <NavbarSearch /> */}
                <Navbar />
                {/* size="w-[80vw] md:w-240" */}
                <DashboardSidenav position="left" size='xl md:w-240'>
                  <Sidebar />
                </DashboardSidenav>
                {/* <DriveContentHeader /> */}

                <DashboardContent>
                  <div>
                    <UserDatatable />
                  </div>
                </DashboardContent>
                <UploadQueue />

                {/* <DriveDialogsContainer /> */}
                {/* <DashboardSidenav position="right" size="lg">
                <DetailsSidebar />
              </DashboardSidenav> */}
              </DashboardLayout>
            </div>
          </div>
        </FileEntryUrlsContext.Provider>
        <EntryDragPreview />
      </FileUploadProvider>
    </Fragment>
  );
}

function Navbar() {
  const { isMobileMode } = useContext(DashboardLayoutContext);
  const activePage = useDriveStore(s => s.activePage);

  const children = isMobileMode ? null : <NavbarSearch />;
  // const searchButton = (
  //   <IconButton elementType={Link} to={SearchPage.path}>
  //     <SearchIcon />
  //   </IconButton>
  // );

  const mobileRightChildren = (
    <Fragment>
      {/* {activePage !== SearchPage && searchButton} */}
      <CreateNewButton isCompact />
    </Fragment>
  );

  return (
    <Fragment>
      <DashboardNavbar
        rightChildren={isMobileMode && mobileRightChildren}
        menuPosition="drive-navbar"
      >
        {children}
      </DashboardNavbar>
      {isMobileMode && <FloatingActionList />}
    </Fragment>
  );
}

function FloatingActionList() {
  const entriesSelected = useDriveStore(s => s.selectedEntries.size);
  if (!entriesSelected) return null;
  return (
    <div className="fixed right-0 top-0 z-10 flex h-54 w-full items-center justify-center gap-10 rounded bg-primary px-6 text-on-primary shadow-xl">
      <IconButton
        onClick={() => {
          driveState().selectEntries([]);
        }}
      >
        <CloseIcon />
      </IconButton>
      <Trans message=":count selected" values={{ count: entriesSelected }} />
      <EntryActionList className="ml-auto" />
    </div>
  );
}

function UserDatatable() {

  const [query, setQuery] = useState('');
  const MaxValue = 108851651149824;
  const { getPlan, user } = useAuth();
  const {trans} = useTrans();
  const { data: members } = useQuery({
    queryKey: ['companyMembers', user?.id, "allCompanyMembers"],
    queryFn: () => { return getcompanyMembersApi({ query: '', companyId: user?.id || 0 }) },
    select: (data) => { return data.data.users }
  })

  // function queryChange(e: React.ChangeEvent<HTMLInputElement>){
  //   console.log(e.nativeEvent.data);
  //   setQuery(e.nativeEvent.data);

  // }

  return (
    <div className='p-24'>
      <h3 className='font-medium text-2xl'><Trans message="Company Members"/></h3>
      <div className='flex justify-between mt-24'>
        <TextField
          size="sm"
          className="min-w-180 max-w-440 flex-auto"
          inputWrapperClassName="mr-24 md:mr-0"
          placeholder={trans(message("Search"))}
          startAdornment={<SearchIcon size="sm" />}
          value={query}
          onChange={(e) => { setQuery(e.target.value) }}
        />
        <div className='flex gap-5'>
          <DialogTrigger type="modal">
            {/* <button className='bg-primary text-white px-10 rounded-[4px] disabled:bg-gray-400 font-semibold text-sm' disabled={members?.length >= (getPlan()?.users_limit || 0)}>
            <div className='flex items-center justify-center gap-10'>
              <i className='fa-solid fa-plus text-sm'></i>
              <span className='text-sm hidden md:flex'>Invite member</span>
            </div>
          </button> */}

            <DataTableAddItemButton disabled={members?.length >= (getPlan()?.users_limit || 0)}>
              <Trans message="Invite member" />
            </DataTableAddItemButton>

            <AddMemberDialog disabled={members?.length >= (getPlan()?.users_limit || 0)} />
          </DialogTrigger>
          <DialogTrigger type="modal">
            <DataTableAddItemButton disabled={members?.length >= (getPlan()?.users_limit || 0)} icon={<i className="fa-solid fa-user-plus"></i>}>
              <Trans message="Add new user" />
            </DataTableAddItemButton>
            <CreateUserDialog company={true} />
          </DialogTrigger>
        </div>
      </div>
      <div className='mt-16'>
        <CompanyTable query={query} />
      </div>


    </div>
  )
}